export function checkoutViewOnly(shoppingCenter: string | null):boolean {
    if (!shoppingCenter) {
        return true;
    }
    return (['Shop_EU_BVG', 'Shop_AM_BR'].includes(shoppingCenter));
}
